
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1> Employee Sports Meet</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm employee-sport-meet section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> Employee <span>Sports Meet</span></h2>
        </div>
        <div class="row text-justify">

            <div class="col-md-12">
                <div class="widget_title inner-title">
                    <h4>Introduction of the Concept: </h4>
                </div>

                <p>
                    Every year in the month of January, a 3-day Annual sports event is organized for the employees where all teaching and non-teaching staff does participate in the sports. It is also one of many such events organized by RGI.
                </p>
                <div class="widget_title inner-title">
                    <h4>Existing Scenario: </h4>
                </div>

                <p>
                    Every year the meet is organized where participation of employees takes place.
                </p>
                <div class="widget_title inner-title">
                    <h4>Reason behind Starting the Concept:</h4>
                </div>

                <p>
                    Annual sports meet is one of the opportunities that bring RGI family together.
                </p>
                <div class="widget_title inner-title">
                    <h4>Vision or Goal of this Concept: </h4>
                </div>

                <p>
                    It is an effort to build interpersonal relationships among employees, promote companionship, commitment, and teamwork.
                </p>
                <div class="widget_title inner-title">
                    <h4>Objectives of the concept: </h4>
                </div>

                <ul class="list-style list-style1">
                    <li> To provide rejuvenation to the employees.</li>
                    <li> Encouragement to their sports interest.</li>
                    <li> To bridge the gap between various authorities.</li>
                </ul>
                <div class="widget_title inner-title">
                    <h4>General Rules & Regulations To Be Followed Strictly:</h4>
                </div>
                <ul class="list-style list-style1">
                    <li>Spot Entry not allowed in any case</li>
                    <li>Those who have registered through online form submission, they only can participate in the events</li>
                    <li>
                        <strong>Please find the Forms under</strong> :
                        <ul class="column-count">
                            <li><a href="https://forms.gle/ci51WjgqfDfcbBVBA" target="_blank">🎾Badminton </a></li>
                            <li><a href="https://forms.gle/gexP6FnGrqe66Mnf9" target="_blank">♟️ Chess </a></li>
                            <li><a href="https://forms.gle/ETkhQ73q1g7NbDkS6" target="_blank">👑 Carom </a></li>
                            <li><a href="https://forms.gle/XuL2uaPySckTHhYC6" target="_blank">🎱 Pool Table </a></li>
                            <li><a href="https://forms.gle/BetzsUh6CGjv1A387" target="_blank">🏓 Table Tennis </a></li>
                            <li><a href="https://forms.gle/JVqChxRkesfKResy5" target="_blank">🪑 Musical Chair </a></li>
                            <li><a href="https://forms.gle/xFjkc3A9RaB2jz6J7" target="_blank">🎙 Solo Singing </a></li>
                            <li><a href="https://forms.gle/jWRUp29uQ38xNtkE6" target="_blank">💃 Solo Dance </a></li>
                            <li><a href="https://forms.gle/Tr1ja9GkwjaUjGeL8" target="_blank">✍ Writing </a></li>
                        </ul>
                    </li>
                </ul>
                <div class="border-line-sm"></div>
                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>EMPLOYEE SPORTS & CULTURAL MEET 2025</h4>
                        </div>
                    </div>
                  <div class="col-md-4 text-end">
                        <!-- < <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/neev-2025-winner-sheet.pdf"
                        class="cmn-button active" target="_blank">
                          Show Result
                        </a> -->
                        <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/neev-2025-winner-sheet.pdf"
                        class="cmn-button active" target="_blank">
                          Show Result
                        </a>
                        <a href="https://drive.google.com/drive/folders/1h8pMH1xZinSuJHa13ecX2VoMUcQvP6bi"
                            target="_blank" class="cmn-white-button"><span>
                                View More</span>
                        </a>
                    </div>
                    <div class="lightBox--gallery">
                      <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>
                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-1.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-1.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-1.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>
                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-2.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-2.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-2.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>

                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-3.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-3.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-3.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>
                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-4.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-4.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-4.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>
                          <li class="col"
                              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-5.webp"
                              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-5.webp">
                              <a href="Javascript:void(0);">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-5.webp"
                                      alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                  <div class="light-gallery-poster">
                                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                  </div>
                              </a>
                          </li>
                          <li class="col"
                          data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-7.webp"
                          data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-7.webp">
                          <a href="Javascript:void(0);">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-7.webp"
                                  alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                              <div class="light-gallery-poster">
                                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                              </div>
                          </a>
                      </li>
                      <li class="col"
                      data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-8.webp"
                      data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-8.webp">
                      <a href="Javascript:void(0);">
                          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-8.webp"
                              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                          <div class="light-gallery-poster">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                          </div>
                      </a>
                  </li>
                      <li class="col"
                      data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-9.webp"
                      data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-9.webp">
                      <a href="Javascript:void(0);">
                          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-9.webp"
                              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                          <div class="light-gallery-poster">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                          </div>
                      </a>
                  </li>
                      <li class="col"
                      data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-10.webp"
                      data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-10.webp">
                      <a href="Javascript:void(0);">
                          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-10.webp"
                              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                          <div class="light-gallery-poster">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                          </div>
                      </a>
                  </li>
                      <li class="col"
                      data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-11.webp"
                      data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-11.webp">
                      <a href="Javascript:void(0);">
                          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-11.webp"
                              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                          <div class="light-gallery-poster">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                          </div>
                      </a>
                  </li>
                      <li class="col"
                      data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-12.webp"
                      data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-12.webp">
                      <a href="Javascript:void(0);">
                          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-12.webp"
                              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                          <div class="light-gallery-poster">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                          </div>
                      </a>
                  </li>
                      <li class="col"
                      data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-13.webp"
                      data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-13.webp">
                      <a href="Javascript:void(0);">
                          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-13.webp"
                              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                          <div class="light-gallery-poster">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                          </div>
                      </a>
                  </li>
                      <li class="col"
                      data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-14.webp"
                      data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-14.webp">
                      <a href="Javascript:void(0);">
                          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-14.webp"
                              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                          <div class="light-gallery-poster">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                          </div>
                      </a>
                  </li>
                      <li class="col"
                      data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-6.webp"
                      data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-6.webp">
                      <a href="Javascript:void(0);">
                          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-6.webp"
                              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                          <div class="light-gallery-poster">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                          </div>
                      </a>
                  </li>
                      <li class="col"
                      data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-15.webp"
                      data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-15.webp">
                      <a href="Javascript:void(0);">
                          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-15.webp"
                              alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                          <div class="light-gallery-poster">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                          </div>
                      </a>
                  </li>

                      </ul>
                    </div>
                </div>
                <div class="border-line-sm"></div>
                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>EMPLOYEE SPORTS & CULTURAL MEET 2024</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">
                        <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/sports_meet_2024_winner.pdf"
                        class="cmn-button active" target="_blank">
                          Show Result
                        </a>
                        <a href="https://drive.google.com/drive/folders/1kPlkkK1ID4ccAo0Ye5v4keAeb-AMALn3"
                            target="_blank" class="cmn-white-button"><span>
                                View More</span>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-1.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-1.avif">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-1.avif"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-2.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-2.avif">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-2.avif"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-3.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-3.avif">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-3.avif"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-4.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-4.avif">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev24-4.avif"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
                <div class="border-line-sm"></div>
                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>EMPLOYEE SPORTS & CULTURAL MEET 2023</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">
                        <a href="https://drive.google.com/file/d/1BFVGE5UhoezaKY_nxhB0npQ3yKjC_ZRg/view?usp=sharing"
                        class="cmn-button active" target="_blank">
                          Show Result
                        </a>
                        <a href="https://drive.google.com/drive/folders/1FyWqxD7mDyGFWvmgGqz8wLeGvXZhPrlq?usp=share_link"
                            target="_blank" class="cmn-white-button"><span>
                                View More</span>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-4.jpg"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-4.jpg">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-4.jpg"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-2.jpg"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-2.jpg">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-2.jpg"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-1.jpg"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-1.jpg">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-1.jpg"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-3.jpg"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-3.jpg">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-sport-23-3.jpg"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>EMPLOYEE SPORTS & CULTURAL MEET 2022</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">
                        <a href="https://drive.google.com/file/d/1v2qolKcbrGGntORVJJX-_5REoGC8kZke/view"
                            class="cmn-white-button mx-2" target="_blank">
                            Show Result
                        </a>
                        <a href="https://drive.google.com/drive/folders/13hkmEpTnooEgn4SDpgNC2xwVFGYPXaRg"
                            target="_blank" class="cmn-button"><span>
                                View More</span>
                        </a>
                    </div>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
                <div class="border-line-sm"></div>
                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4 class="fw-bold">EMPLOYEE SPORTS & CULTURAL MEET 2021</h4>
                        </div>
                    </div>

                    <div class="col-md-4 text-end">
                        <a href="https://drive.google.com/file/d/1Yn4b1jq6LAolp7g2IoFODQdozoi2Zktn/view"
                            class="cmn-button" target="_blank">
                            Show Result
                        </a>
                        <a href="https://drive.google.com/drive/folders/1Vv1Mncp08hHjj9cpxHIs-NH9k2wgXTAB"
                            target="_blank" class="cmn-white-button"><span>
                                View More</span>
                        </a>
                    </div>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-7.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-7.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-7.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-8.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-8.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-8.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
                <div class="border-line-sm"></div>
                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4 class="fw-bold">EMPLOYEE SPORTS MEET 2020</h4>
                        </div>
                    </div>

                    <div class="col-md-4 text-end">
                        <a href="https://drive.google.com/file/d/1t3-H9ZhotgCAdzY-Gi9f2izyUHSTSJVz/view"
                        class="cmn-button" target="_blank">
                            Show Result
                        </a>
                        <a href="https://drive.google.com/drive/u/0/folders/13ioROIjDVeLnGqG92VPrRM8b9Nvh2U-s"
                            target="_blank" class="cmn-white-button"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-9.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-9.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-9.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-10.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-10.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-10.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-11.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-11.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-11.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-12.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-12.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-12.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
                <div class="border-line-sm"></div>
                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4 class="fw-bold">EMPLOYEE SPORTS MEET 2019</h4>
                        </div>
                    </div>

                    <div class="col-md-4 text-end">
                        <a href="https://drive.google.com/file/d/1t7B8lOxalOWpZnSkjXifhXPxUP4wWgWR/view?usp=sharing"
                            target="_blank" class="cmn-button">
                            Show Result
                        </a>
                        <a href="https://www.amazon.com/clouddrive/share/q1yyN0jHAw6nvgsC8k8gbQaVda24jo1YRbtIGCWZtJw"
                            target="_blank" class="cmn-white-button"><span>
                                View More</span>
                        </a>
                    </div>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-13.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-13.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-13.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-14.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-14.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-14.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-15.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-15.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-15.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-16.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-16.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-16.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

                <div class="border-line-sm"></div>
                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4 class="fw-bold">EMPLOYEE SPORTS MEET 2018</h4>
                        </div>
                    </div>

                    <div class="col-md-4 text-end">
                        <a href="https://drive.google.com/file/d/1CSOoCAjCk8I_deBMaprdHHm3IsEcdgpW/view?usp=sharing"
                            target="_blank" class="cmn-button">
                            Show Result
                        </a>
                        <a href="https://photos.app.goo.gl/nSgV8gWzsf7468AD3" target="_blank"
                        class="cmn-white-button"><span>
                                View More</span>
                        </a>
                    </div>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-17.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-17.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-17.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-18.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-18.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-18.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-19.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-19.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-19.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-20.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-20.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-20.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
                <div class="border-line-sm"></div>
                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4 class="fw-bold">EMPLOYEE SPORTS MEET 2017</h4>
                        </div>
                    </div>

                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/eQXayPnmnSpRY8yt9" target="_blank"
                        class="cmn-white-button"><span>
                                View More</span>
                        </a>
                    </div>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-21.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-21.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-21.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-22.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-22.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-22.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-23.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-23.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-23.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-24.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-24.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-24.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
                <div class="border-line-sm"></div>
                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4 class="fw-bold">EMPLOYEE SPORTS MEET 2016</h4>
                        </div>
                    </div>

                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/V7PkQ3RuUzYGZegy5" target="_blank"
                        class="cmn-white-button"><span>
                                View More</span>
                        </a>
                    </div>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-25.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-25.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-25.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-26.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-26.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-26.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-27.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-27.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-27.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-28.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-28.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/employee-sport/emp-28.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

            </div>

        </div>


    </div>
</section>
